<template>
  <div v-if="cafes.length > 0" id="result">
    <ion-card class="cafelist" v-for="cafe in cafes" :key="cafe.id">
      <a :href="'/cafemenu?id=' + cafe.uuid">
        <div class="img-container">
          <img :src="cafe.shopImgUrl" class="cafelist-img" />
        </div>
      </a>
      <h2 class="h2-banner">{{ cafe.shopName }}</h2>
      <div v-if="cafe.isOpen !== null" class="cafe-info-line status-row">
        <span v-if="cafe.isOpen" class="status-badge open">Open Now</span>
        <span v-else class="status-badge closed">Closed</span>
      </div>
      <div class="cafe-info-line">
        <ion-icon
          src="assets/icon/distance.svg"
          class="banner-icon"
          color="primary"
        >
        </ion-icon>
        <span class="cafeinfo-txt">{{
          cafe.distance ? cafe.distance : cafe.address
        }}</span>
      </div>
      <div class="cafe-info-line">
        <ion-icon src="assets/icon/time-outline.svg" class="banner-icon">
        </ion-icon>
        <span class="cafeinfo-txt">{{
          getFormattedHours(cafe.businessHours)
        }}</span>
      </div>
      <span class="address-hide" id="destinationSpan">{{ cafe.address }}</span>
    </ion-card>
  </div>
  <div v-else class="center-img">
    <img src="assets/icon/empty-message.png" />
    <h1 class="no-result">No favorites yet</h1>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonCard, IonIcon } from "@ionic/vue";
import { formatBusinessHours } from "@/utils/businessHours";

export default defineComponent({
  name: "CoffeeShopCard",
  components: {
    IonCard,
    IonIcon,
  },
  props: {
    cafes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getFormattedHours(businessHours) {
      return formatBusinessHours(businessHours);
    },
  },
});
</script>

<style scoped>
a {
  text-decoration: none;
}
.h2-banner {
  font-family: "Gilroy";
  font-style: normal;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  margin-top: 0px;
  margin-bottom: 5px;
  text-align: left;
}
.cafeinfo-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 132.6%;
  letter-spacing: 0.02em;
  color: #828282;
}
.banner-icon {
  vertical-align: middle;
  padding-right: 5px;
  width: 11px;
}
.cafelist {
  border-radius: 2px;
  box-shadow: none;
}
.cafelist-img {
  border: none;
  box-shadow: none;
  border-radius: 8px;
  width: auto;
  height: 128px;
  object-fit: cover;
  margin-bottom: 10px;
}
ion-card {
  margin-top: 5px;
  margin-bottom: 10px;
}
div.img-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.img-container img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
}
.center-img {
  text-align: center;
  display: block !important;
  padding: 40px 20px;
  min-height: 300px;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.center-img img {
  max-width: 250px;
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}
.no-result {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #1b1b1b;
  margin-top: 0px;
  margin-bottom: 5px;
  display: block;
}
.address-hide {
  color: #ffffff;
  font-size: 1px;
}
.status-badge {
  display: inline-block;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-top: 5px;
  margin-left: 5px;
}
.status-badge.open {
  background-color: #d4edda;
  color: #155724;
}
.status-badge.closed {
  background-color: #f8d7da;
  color: #721c24;
}
.cafe-info-line {
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
  flex-wrap: nowrap;
}
.cafe-info-line .cafeinfo-txt {
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
